module.exports = __webpack_public_path__ + "img/logo_huge_drk.506af9db.png";